import React, { useEffect, useState } from 'react';
import MainLayout from '../../layouts/mainLayout';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import checkbox from '../../assets/images/svgs/check.svg';
import checkRound from '../../assets/images/svgs/checkRound.svg';
import disableRound from '../../assets/images/svgs/disableRound.svg';
import { getUserLocation } from '../../api/apis/locations';
import Loader from '../../components/Loader';
import { addAssessmentData } from '../../functions/localStorage';
import { createAssesment } from '../../api/apis/assesments';
import { Spinner } from 'react-bootstrap';
import { roundedNumber } from '../../functions/common';
import { checkIs2026, getPathAcctoYear } from '../../utils/functions/common';

const Location = () => {

  const navigate = useNavigate();
  const [selected, setSelected] = useState('');
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const is2026 = checkIs2026();

  const changeSelected = (id) => {
    setSelected(id)
  }

  const goToQuestion = async () => {
    const selectedLocation = locations?.find(v => v?.id === selected);
    if (selectedLocation?.latestAssessmentsId) {
      const payload = {
        assessmentId: selectedLocation?.latestAssessmentsRecordId ?? '',
        locationId: selectedLocation?.recId ?? '',
        address: selectedLocation?.address ?? '',
        submissionStatus: selectedLocation?.latestsubmissionStatus,
        isSolelyManaged:selectedLocation?.isSolelyManaged
      }
      addAssessmentData(payload);
      navigate(getPathAcctoYear("/questions"))
    } else {
      try {
        const payload = {
          locationId: selectedLocation?.recId ?? ''
        }
        setBtnLoading(true)
        const response = await createAssesment(payload);
        if (response?.data?.status === 'success') {
          const assesment = response?.data?.data?.assessment ?? {};
          addAssessmentData({
            assessmentId: assesment?.id ?? '',
            locationId: assesment?.locationId ?? '',
            address: selectedLocation?.address ?? '',
            submissionStatus: selectedLocation?.latestsubmissionStatus,
            isSolelyManaged:selectedLocation?.isSolelyManaged
          });
          navigate(getPathAcctoYear("/questions"))
        }
        setBtnLoading(false)
      } catch (error) {
        setBtnLoading(false)
      }
    }

  }

  const fetchUserLocations = async () => {
    try {
      setLoading(true)
      const response = await getUserLocation();
      setLocations(response?.data?.data ?? [])
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUserLocations();
  }, []);

  const goToInstructions = () => navigate(getPathAcctoYear("/instructions"))

  return (
    <>
      {loading ? <Loader /> :
        <MainLayout locationClick={goToInstructions} showLocationBtn={!is2026} locationBtnText={'Instructions'} formTransparent hrLine>
          <div className='location__section'>
            <h3>
              Locations
            </h3>
            <br />
            <p>Select the workspace location to start your assessment.</p>
            <div className='location__list'>
              {locations?.map((v, i) => {
                const isSelected = selected === v?.id;
                const isCompleted = v?.latestAssessmentsId && v?.latestsubmissionStatus === 'submitted';
                const imgSrc = isCompleted ? disableRound : isSelected ? checkbox : checkRound;
                return <button onClick={() => changeSelected(v?.id)} disabled={isCompleted} className={`location__list__item align-items-center ${is2026 ? "justify-content-between" :""}`}>
                  {is2026 ? <div className='d-flex gap-1 align-items-center'>
                    <div className='check__box'>
                    <img src={imgSrc} className='check__box' alt='' />
                  </div>
                  <div>{v?.address}</div>
                  </div>:
                  <>
                    <div className='check__box'>
                    <img src={imgSrc} className='check__box' alt='' />
                  </div>
                  <div>{v?.address}</div>
                  </>
                  }
                  {v?.latestAssessmentsId && v?.latestsubmissionStatus !== 'not_started' ? <div className='mx-3' style={{width:200,display:"flex"}}>
                    <div className={`complete__percent ${isCompleted ? 'is__completed' : ''}`}>
                    <span>{isCompleted ? 'Assessment Submitted' : `${roundedNumber(v?.latestcompletionPercentage ?? 0)}% Completed`}</span>
                  </div>
                  </div> : ""}
                </button>
              })}
            </div>
            <div className='next__btn__section d-flex justify-content-center gap-2'>
             {is2026 ? <button onClick={goToInstructions}>
                Instructions
              </button>:""}
              <button onClick={goToQuestion} disabled={!selected || btnLoading}>
                {btnLoading ? <Spinner animation="border" role="status" /> : 'NEXT'}
              </button>
            </div>
          </div>
        </MainLayout>
      }
    </>
  )
}

export default Location